var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticClass: "ma-1 pl-0 pr-0",
      attrs: {
        flat: "",
        small: "",
        disabled: _vm.disabled,
        loading: _vm.loading
      },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: "38",
            viewBox: "0 0 38 38",
            width: "38",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          },
          on: {
            mouseover: function($event) {
              return _vm.$emit("mouseover")
            },
            mouseleave: function($event) {
              return _vm.$emit("mouseleave")
            }
          }
        },
        [
          _c("g", { attrs: { fill: "none" } }, [
            _vm._v("\n       background white square\n      "),
            _c("rect", {
              attrs: { fill: "#f4f4f4", height: "38", rx: "4", width: "38" }
            }),
            _vm._v(" "),
            _c("use", { attrs: { fill: "#000", "xlink:href": "#a" } }),
            _vm._v(" "),
            _c("use", { attrs: { fill: "#0d84ab", "xlink:href": "#a" } }),
            _vm._v(" "),
            _c("g", { attrs: { transform: "translate(3 3)" } }, [
              _c("path", {
                attrs: {
                  d:
                    "m16.4995319 0c-9.11353873 0-16.4995319 7.38765603-16.4995319 16.5 0 9.1115118 7.38599317 16.5 16.4995319 16.5 9.110834 0 16.5004681-7.3884882 16.5004681-16.5 0-9.11234397-7.3896341-16.5-16.5004681-16.5",
                  fill: "#13b5ea"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "m16.8210417 13.1529405c-.5917606-.3667099-1.2823572-.5604607-1.9972182-.5604607-.7887004 0-1.5396445.2313595-2.1716716.669108-.9878365.6847018-1.5775054 1.8030753-1.5775054 2.9919777 0 .2984232.037861.5947061.1124324.8804911.3796556 1.4476786 1.6564696 2.5426103 3.1772881 2.7245384.1470512.0171227.2943115.0258878.4375975.0258878.3046657 0 .601069-.0378125.9057347-.1150682.396076-.0928496.7734306-.2491956 1.1219188-.4645536.329244-.2079178.6324455-.4880972.9513352-.8788603l.0209177-.0210976c.1061571-.1291332.1555228-.2951617.1353372-.4553807-.0180937-.1434021-.0884817-.2672355-.1980902-.3484661-.1039608-.0780711-.2277933-.1210816-.3485928-.1210816-.1177665 0-.2907555.0415836-.4472196.2403285l-.0122369.0158996c-.0516666.0671656-.1051112.1365735-.1666091.2054717-.2107455.230748-.452972.4208297-.719463.5648434-.3815381.1982353-.7937206.3002577-1.2242061.3033153-1.3523268-.0144727-2.180457-.8917023-2.5040532-1.7064547-.0508299-.1466635-.0871221-.2805871-.1104453-.4047262-.0004183-.0126381-.0013596-.0257859-.0021963-.0387298l5.2357952-.0009173c.3636535-.0075421.6683192-.1369811.8577286-.3643657.1714203-.2058794.2358467-.4751533.181147-.7590019-.2228777-1.0285815-.7961262-1.8525067-1.6577247-2.3826971zm-4.5758429 2.4481301c.2985996-1.1411018 1.350758-1.9376104 2.5596942-1.9376104 1.2152115 0 2.2624542.7944702 2.5623089 1.9376104zm13.6366416-.3005635c-.5269159 0-.9556233.4167528-.9556233.9289033 0 .5123543.4287074.9291071.9556233.9291071.52587 0 .9537408-.4167528.9537408-.9291071 0-.5121505-.4278708-.9289033-.9537408-.9289033zm-3.4273588-2.1263671c0-.2910849-.2441091-.5278462-.5434408-.5278462l-.1530127-.0021403c-.4644766 0-.9036429.1387138-1.2735718.4017705-.0708063-.2130138-.2779957-.362735-.511646-.362735-.3011097 0-.5384206.2300346-.5403032.5238713l.001778 6.0813915c.0019872.28976.2439.5254001.5394665.5254001.2973446 0 .5393619-.2357421.5393619-.5256039v-3.7400741c0-1.2117327.1070984-1.7182775 1.1844626-1.8481242.0893184-.0103959.1852259-.0110074.2095949-.0110074.3171118-.0112113.5473106-.2276904.5473106-.5149023zm-14.20832125 3.0552704 2.79407655-2.7315709c.1021828-.0977418.1585559-.2291173.1585559-.3698695 0-.2905753-.2436907-.5270308-.5431271-.5270308-.1449594 0-.2816563.0559543-.3847803.1573652l-2.7942858 2.7178117-2.80537212-2.7229077c-.10228736-.0981494-.2378338-.1522692-.3818519-.1522692-.29797208 0-.54030318.2364555-.54030318.5270308 0 .141058.05783733.2748796.16284399.3766981l2.79606375 2.7226019-2.79188022 2.7259653c-.10772595.1001879-.16702752.2347229-.16702752.3786346 0 .2904734.2423311.526929.54030318.526929.14182174 0 .27736819-.0538141.38206108-.1520654l2.80244365-2.7287172 2.79031139 2.7159771c.1069938.1071185.2459917.1661304.391474.1661304.2994364 0 .5431271-.2369651.5431271-.5282539 0-.1391214-.0562685-.2709046-.1583467-.3713982zm17.63568005-3.646715c-2.0639456 0-3.7431109 1.6359257-3.7431109 3.646715 0 2.0102796 1.6791653 3.6457977 3.7431109 3.6457977 2.0628997 0 3.7412283-1.6355181 3.7412283-3.6457977 0-2.0107893-1.6783286-3.646715-3.7412283-3.646715zm0 6.2017596c-1.4469792 0-2.6241206-1.1461978-2.6241206-2.5550446 0-1.4104776 1.1771414-2.5580004 2.6241206-2.5580004 1.4454104 0 2.6212967 1.1475228 2.6212967 2.5580004 0 1.4088468-1.1758863 2.5550446-2.6212967 2.5550446z",
                  fill: "#fff"
                }
              })
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21053cc1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21053cc1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xero/XeroButton.vue
// module id = null
// module chunks = 